export enum WallType {
  VOID,
  SOLID,
  SOLID_MASS,
}

export enum WallLayerType {
  MASS = "MASS",
  STRUCTURE = "STRUCTURE",
  SUBSTRATE = "SUBSTRATE",
  FINISH = "FINISH",
}
